import React, { useState, useLayoutEffect } from "react";
import { FieldEntry } from "../../generic-components/FieldEntry";
import {
  validateTimeField,
  FieldChangeResult
} from "../controls/controlUtility";
import {
  Time,
  isNoTime,
  formatTime,
  parseTime,
  isValidTime
} from "../../pace-fns/pace-fns";

const HelpText = "valid format is hh:mm:ss ms";
const FieldName = "Time";

export type TimeFieldChangeResult = FieldChangeResult<{
  value: Time | undefined;
}>;

type Props = {
  time: Time;
  onTimeChange(change: TimeFieldChangeResult): void;
};

const setTime = (time: Time) =>
(time && !isNoTime(time) && formatTime(time)) || "";


export const TimeControl = ({ time, onTimeChange }: Props) => {
  const [isValid, setIsValid] = useState(true);
  const [timeValue, setTimeValue] = useState(setTime(time));

  useLayoutEffect(() => {
    setTimeValue(setTime(time));
  }, [time]);

  const onFieldChange = (value: string) => {
    const valid = validateTimeField(value);
    setIsValid(valid);
    const newTime = parseTime(value);
    onTimeChange({ data: { value: newTime }, valid: isValidTime(newTime) });
  };

  return (
    <FieldEntry
      fieldName={FieldName}
      value={timeValue}
      onFieldChange={onFieldChange}
      isValid={isValid}
      onErrorText={HelpText}
    ></FieldEntry>
  );
};
